import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useFillAnalyses from 'hooks/useFillAnalyses';
import { fillAnalysesSelectors } from 'features/fillAnalyses';

const FillAnalysesList = () => {
  const { getFillAnalyses } = useFillAnalyses();
  const { data, pagination } = useCustomSelector(fillAnalysesSelectors.getFillAnalysesData);
  const fetching = useCustomSelector(fillAnalysesSelectors.fillAnalysesIsFetching);
 
  return (
    <BaseAnalysesList
      fetchData={getFillAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FillAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);